<template>
    <div class="header" :class="String(this.$router.currentRoute.value.path).search('dashboard') !== -1 ? 'active' : ''">
        <div class="container" :class="menuStatus && 'z-index'">
            <div class="header-menu">
                <div class="mobile-menu" v-on:click="showMenu" :class="menuStatus && 'open'">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <router-link to="/" class="logo"></router-link>
                <div class="header-nav" :class="menuStatus && 'active'">
                    <router-link to="/" class="menu">
                        <b>Главная</b>
                    </router-link>
                    <router-link to="/about" class="menu">
                        <b>О компании</b>
                    </router-link>
                    <router-link to="/news" class="menu">
                        <b>Новости</b>
                    </router-link>
                    <router-link to="/reviews" class="menu">
                        <b>Отзывы</b>
                    </router-link>
                    <router-link to="/faq" class="menu">
                        <b>FAQ</b>
                    </router-link>
                    <router-link to="/contacts" class="menu">
                        <b>Контакты</b>
                    </router-link>
                    <router-link to="/mobile-app" class="menu md-block">
                        <b>Скачать приложение</b>
                    </router-link>
                    <router-link to="/auth/login" class="auth-menu ml-auto" v-if="!isAuth">Войти</router-link>
                    <router-link to="/auth/register" class="auth-menu active" v-if="!isAuth">Регистрация</router-link>
                    <a class="auth-menu ml-auto" v-if="isAuth" v-on:click="logout">Выйти</a>
                    <router-link to="/dashboard" class="auth-menu active" v-if="isAuth">Мой кабинет</router-link>
                </div>
                <div class="header-icons">
                    <router-link to="/mobile-app" class="download-app-icon ease md-block"></router-link>
                    <router-link to="/dashboard/notifications" class="notification-icon ease md-block" :class="noticeStatus && 'active'" v-if="isAuth"></router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isAuth: false,
            menuStatus: false,
            noticeStatus: false
        }
    },
    created() {
        if (localStorage.getItem('isAuth') === 'true' && localStorage.getItem('token')) {
            this.isAuth = true
        }
    },
    computed: {
        balance() {
            return (this.$store.getters.getCurrencies)
                ? this.$store.getters.getCurrencies
                : this.$store.dispatch('getCurrencies')
        },
        notifications() {
            return (this.$store.getters.notifications)
            ? this.$store.getters.notifications
            : this.$store.dispatch('getNofitications')
        }
    },
    watch: {
        $route() {
            this.menuStatus = false
        },
        notifications() {
            for (const prop in this.notifications.notifications) {
                if(this.notifications.notifications[prop][0].view === false) {
                    this.noticeStatus = true
                    break
                }
            }
        }
    },
    methods: {
        showMenu() {
            this.menuStatus = (this.menuStatus) ? false : true
        },
        logout() {
            this.$store.dispatch('logout')
            this.isAuth = false
        }
    }
}
</script>